export default class AWSSettings {
    public cloudFront: string;
    public videoCloudFront: string;
    constructor(settings: any) {
        this.cloudFront = settings.cloudFront;
        this.videoCloudFront = settings.videoCloudFront;
    }
}